module.exports = __webpack_public_path__ + "img/博爱香港有限公司(1).1ac5937f.png";